module.exports = __webpack_public_path__ + "img/iconleft.fdd1b26a.png";